/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2021-12-01 13:44:01
 * @Description:
 */
import "./FTCanvas.scss";

import {
  CanvasLoading,
  IconClose,
  IconLargePro,
  IconRight,
  ShareIcon
} from "src/assets";
import { EnumImageSizeType, EnumsShowStatus } from "src/constant";
import { FTCanvasStore, FTImageStore, FTUserStore } from "src/store";
import FTEventTarget, { FTEVENT_CONSTANTS } from "src/utils/FTEventTarget";
import { FTWatermark, FTimageCompare } from "src/components";
import type { Position, Scale, Size } from "src/store/types";
import { actionFeatureClickUp, actionStartDownload } from "src/analyze/actions";
import { utils, withPublicUrl, withUnit } from "src/utils";
import styles from "./FTCanvas.module.scss";

import FTCanvasPanel from "./FTCanvasPanel";
import FTLang from "src/utils/FTLang";
import FTSlider from "src/components/FTSlider/FTSlider";
import React from "react";
import { autorun } from "mobx";
import clsx from "clsx";
import loadable from "@loadable/component";
import Share from "src/components/share";
import { myBrowserOS } from "src/utils/initTopFixedHeight";

const FTMoreLink = loadable(
  () =>
    import(
      /* webpackChunkName: "more-link" */
      "src/components/FTMoreLink/FTMoreLink"
    ),
  { ssr: false }
);

// import FTMoreLink from 'src/components/FTMoreLink/FTMoreLink';

interface IState {
  showStatus: EnumsShowStatus;
  showPanel: boolean;
  loading: boolean;
  showDownload: boolean;
  showWaterMark: boolean;
  currentIntensity: number;
  smallSize: Size;
  largerSize: Size;
  canvasSize: Size;
  waterSize: Size & Position & Scale;
  waterCloseSize: Size & Position & Scale;
  waterCloseShow: boolean;
  waterMarkText: string;
  isMobile: boolean;
  mobileShowCenterAd: boolean;
  waterShow: boolean;
  originSize: Size;
  resultSize: Size;
  originCanvasSize: Size;
  resultCanvasSize: Size;
  containerCanvasSize: Size;
}

interface Iprops {
  showAd?: boolean;
}
class FTCanvas extends React.Component<Iprops, IState> {
  canvasRef: HTMLDivElement | null = null;
  waterCloseRef: HTMLDivElement | null = null;
  canvasContainRef: HTMLDivElement | null = null;
  imageBlandMaskTimer: any;
  observe: any;
  hasCompare: boolean = false;
  handelWaterClose: any = null;
  state: IState = {
    containerCanvasSize: {
      width: 0,
      height: 0
    },
    showStatus: EnumsShowStatus.origin,
    originCanvasSize: {
      width: 0,
      height: 0
    },
    resultCanvasSize: {
      width: 0,
      height: 0
    },
    originSize: {
      width: 0,
      height: 0
    },
    resultSize: {
      width: 0,
      height: 0
    },
    loading: true, // 图片加载loading
    showPanel: false,
    showDownload: false,
    showWaterMark: false,
    mobileShowCenterAd: false,
    currentIntensity: FTImageStore.currentIntensity,
    smallSize: {
      width: 0,
      height: 0
    },
    largerSize: {
      width: 0,
      height: 0
    },
    waterMarkText: "goart_remove_watermark",
    isMobile: false,
    canvasSize: {
      width: 0,
      height: 0
    },
    waterShow: false,
    waterCloseShow: false,
    waterCloseSize: {
      width: 0,
      height: 0,
      x: 0,
      y: 0,
      scale: 1
    },
    waterSize: {
      width: 0,
      height: 0,
      x: 0,
      y: 0,
      scale: 1
    }
  };
  originalCanvasRef: HTMLCanvasElement | null = null;
  resultCanvasRef: HTMLCanvasElement | null = null;
  componentDidMount() {
    this.drawCanvasResize();
    this.handelWaterClose = (el: any) => {
      requestAnimationFrame(() => {
        try {
          if (
            FTCanvasStore.canvas &&
            FTCanvasStore.waterMark &&
            this.canvasRef
          ) {
            const {
              offsetHeight,
              offsetWidth,
              height,
              width,
              offsetTop,
              offsetLeft
            } = FTCanvasStore.canvas;
            let heightGetScacls = offsetHeight / height;
            let widthGetScacls = offsetWidth / width;
            let bottoms = offsetTop + offsetHeight;
            let lefts =
              offsetLeft +
              FTCanvasStore.waterInfo.x * widthGetScacls +
              FTCanvasStore.waterInfo.width * widthGetScacls;
            // this.waterCloseRef.style.left = lefts + "px";
            let waterGap =
              (height - FTCanvasStore.waterInfo.y) * heightGetScacls;
            // this.waterCloseRef.style.top = bottoms - waterGap + "px";
            // let doms: HTMLDivElement = this.waterCloseRef.querySelector(
            //   ".canvas_content_touch"
            // ) as HTMLDivElement;
            // if (doms) {
            //   doms.style.transform = `scale(${widthGetScacls})`;
            // }
            const isShow =
              FTImageStore.currentEffect &&
              FTImageStore.currentEffect.name !== "Original" &&
              !FTUserStore.isVip;
            // if (isShow) {
            //   this.waterCloseRef.style.display = "flex";
            // } else {
            //   this.waterCloseRef.style.display = "none";
            // }
            this.setState({
              waterCloseShow: isShow,
              waterCloseSize: {
                x: lefts,
                y: bottoms - waterGap,
                width: 0,
                height: 0,
                scale: widthGetScacls
              },
              waterShow: isShow,
              waterSize: {
                width: FTCanvasStore.waterInfo.width * widthGetScacls,
                height: FTCanvasStore.waterInfo.height * heightGetScacls,
                x: offsetLeft + FTCanvasStore.waterInfo.x * widthGetScacls,
                y: bottoms - waterGap,
                scale: widthGetScacls
              }
            });
          }
        } catch (error) {}
      });
    };
    FTCanvasStore.compareCanvas = this.originalCanvasRef;
    // FTCanvasStore.canvas = this.resultCanvasRef;
    this.observe = new ResizeObserver(this.handelWaterClose);
    this.observe.observe(this.canvasRef as HTMLDivElement);
    autorun(() => {
      let { loading, canvas, ctx, isMobile, hasCompare } = FTCanvasStore;
      this.hasCompare = hasCompare;
      let { isVip } = FTUserStore;
      let {
        currentEffect,
        currentIntensity,
        mobileShowCenterAd,
        acturalSize,
        resultSize,
        showStatus
      } = FTImageStore;
      let waterMarkText = this.getWaterMark();
      this.setState(
        {
          showStatus: showStatus,
          loading,
          showPanel: !!(canvas && ctx),
          showWaterMark: !isVip && currentEffect,
          currentIntensity,
          waterMarkText,
          isMobile,
          mobileShowCenterAd: mobileShowCenterAd,
          originSize: { ...acturalSize },
          resultSize: { ...resultSize }
        },
        () => {
          this.drawCnavasResizeTimer();
        }
      );
    });
    // 长按 显示
    // this.canvasRef!.addEventListener("touchstart", this.touchStart, true)
    // this.canvasRef!.addEventListener("touchend", this.touchEnd, true)
    window.addEventListener("resize", this.handleBeforeCanvasResize);
    FTEventTarget.getInstance().addEvent(
      FTEVENT_CONSTANTS.CHANGE_AD_SHOW,
      this.handleBeforeCanvasResize
    );
    // FTCanvasStore.canvas!.addEventListener("mousemove", this.handleCanvasMove)
  }

  handleCanvasMove = (e) => {
    let rect = this.canvasRef!.getBoundingClientRect();
    const { waterInfo } = FTCanvasStore;
    let x = e.clientX - rect.left;
    let y = e.clientY - rect.top;
    // 检查鼠标是否在水印上
    if (
      x > waterInfo.x &&
      x < waterInfo.x + waterInfo.width &&
      y > waterInfo.y &&
      y < waterInfo.y + waterInfo.height
    ) {
      if (!FTCanvasStore.waterMarkHover) {
        FTCanvasStore.waterMarkHover = true;
        FTCanvasStore.draw();
      }
    } else {
      if (FTCanvasStore.waterMarkHover) {
        FTCanvasStore.waterMarkHover = false;
        FTCanvasStore.draw();
      }
    }
  };

  touchStart = (e: any) => {
    this.imageBlandMaskTimer = setTimeout(async () => {
      FTCanvasStore.downloadImage = await FTCanvasStore.getDownloadImage();
      this.touchEnd();
    }, 800);
  };
  touchEnd = () => {
    clearTimeout(this.imageBlandMaskTimer);
    this.imageBlandMaskTimer = null;
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleBeforeCanvasResize);
    this.observe?.disconnect();
    FTEventTarget.getInstance().removeEvent(
      FTEVENT_CONSTANTS.CHANGE_AD_SHOW,
      this.handleBeforeCanvasResize
    );

    // this.canvasRef!.removeEventListener("touchstart", this.touchStart, true)
    // this.canvasRef!.removeEventListener("touchend", this.touchEnd, true)
  }

  getWaterMark = (): string => {
    let { showFreeTry, showDiscount, activeBlackFriday, blackFridayGroupA } =
      FTUserStore;
    if (activeBlackFriday) {
      return "goart_remove_watermark_discount";
    }
    if (showDiscount !== 0) {
      if (blackFridayGroupA) {
        return "goart_remove_watermark_discount";
      }
    }
    if (showFreeTry) return "goart_remove_watermark_free";
    return "goart_remove_watermark";
  };

  handleBeforeCanvasResize = () => {
    setTimeout(() => {
      // if (this.canvasRef) {
      //   this.canvasRef.style.width = "unset";
      //   this.canvasRef.style.height = "unset";
      // }
      //@ts-ignore
      // if (FTCanvasStore.canvas) {
      //   this.canvasRef?.removeChild(FTCanvasStore.canvas);
      // }

      FTCanvasStore.canvas = null;
      FTCanvasStore.ctx = null;
      this.drawCnavasResizeTimer();
    }, 100);
  };
  maxSilderWithContainer(width, height, maxWidth, maxHeight) {
    if (!this.canvasContainRef) return { width, height };
    // let { width: containerWidth, height: containerHeight } =
    //   this.canvasContainRef.getBoundingClientRect();
    // let maxHeight = this.state.showWaterMark
    //     ? containerHeight - 240
    //     : containerHeight - 150,
    //   maxWidth = containerWidth - (this.state.isMobile ? 32 : 200);
    let scale = 1;
    const widthRatio = width / maxWidth;
    const heightRatio = height / maxHeight;
    // 根据 canvas 和 父容器的宽高比来设置 缩放大小
    if (widthRatio > heightRatio) {
      scale = widthRatio;
    } else {
      scale = heightRatio;
    }
    return {
      width: width / scale,
      height: height / scale
    };
  }

  drawCanvasResize = () => {
    if (this.canvasRef && this.canvasContainRef) {
      let {
        originSize: { width: imgWidth, height: imgHeight },
        resultSize: { width: resultWidth, height: resultHeight },
        showStatus
      } = this.state;
      let { width: containerWidth, height: containerHeight } =
        this.canvasContainRef.getBoundingClientRect();
      const { showWaterMark, isMobile } = this.state;
      let maxHeight = showWaterMark
          ? isMobile
            ? containerHeight - 32
            : containerHeight - 240
          : isMobile
            ? containerHeight - 32
            : containerHeight - 150,
        maxWidth = containerWidth - (this.state.isMobile ? 32 : 200);

      const originCanvasSize = this.maxSilderWithContainer(
        imgWidth,
        imgHeight,
        maxWidth,
        maxHeight
      );
      const resultCanvasSize = this.maxSilderWithContainer(
        resultWidth || imgWidth,
        resultHeight || imgHeight,
        maxWidth,
        maxHeight
      );
      this.setState({
        originCanvasSize,
        resultCanvasSize,
        containerCanvasSize: {
          width: Math.min(
            showStatus === EnumsShowStatus.result
              ? resultCanvasSize.width
              : originCanvasSize.width,
            maxWidth
          ),

          height: Math.min(
            showStatus === EnumsShowStatus.result
              ? resultCanvasSize.height
              : originCanvasSize.height,
            maxHeight
          )
        }
      });
      this.originalCanvasRef!.width = 2 * (originCanvasSize.width || 0);
      this.originalCanvasRef!.height = 2 * originCanvasSize.height;

      let multiple = 1;
      let { isSafari } = myBrowserOS();
      if (isSafari) {
        if (
          Math.max(resultCanvasSize.width * 2, resultCanvasSize.height * 2) <=
          4096
        ) {
          multiple = 2;
        }
      } else {
        multiple = 2;
      }
      this.resultCanvasRef!.width = resultCanvasSize.width * multiple;
      this.resultCanvasRef!.height = resultCanvasSize.height * multiple;

      this.canvasRef.style.width =
        Math.min(
          showStatus === EnumsShowStatus.result
            ? resultCanvasSize.width
            : originCanvasSize.width,
          maxWidth
        ) + "px";
      this.canvasRef.style.height =
        Math.min(
          showStatus === EnumsShowStatus.result
            ? resultCanvasSize.height
            : originCanvasSize.height,
          maxHeight
        ) + "px";
      if (!FTCanvasStore.canvas || !FTCanvasStore.ctx) {
        FTCanvasStore.setCanvas(this.resultCanvasRef as HTMLCanvasElement);
      }
      // setTimeout(()=>{
      FTCanvasStore.draw();
      // },100)
    }
  };

  drawerTimer: any = null;
  drawCnavasResizeTimer = () => {
    if (this.drawerTimer) {
      cancelAnimationFrame(this.drawerTimer);
      this.drawerTimer = null;
    }
    this.drawerTimer = requestAnimationFrame(() => {
      this.drawCanvasResize();
      if (this.handelWaterClose) {
        this?.handelWaterClose();
      }
      cancelAnimationFrame(this.drawerTimer);
      this.drawerTimer = null;
    });
  };

  removeWaterMark = () => {
    if (FTUserStore.userInfo) {
      !FTUserStore.isVip &&
        FTUserStore.showPaymnet({
          vipType: "vip",
          position: "goart_remove_watermark",
          otherParam: {
            scenesId: "012"
          }
        });
    } else {
      FTUserStore.showLogin({
        isSignIn: false,
        options: {
          position: "goart_remove_watermark"
        },
        isShowScenses: true,
        otherParam: {
          scenesId: "015",
          width: FTImageStore.currentSize.width,
          height: FTImageStore.currentSize.height,
          imgSrc: FTCanvasStore.canvas!.toDataURL("image/jpeg")
        },
        callback: () => {
          this.removeWaterMark();
        }
      });
    }
  };

  downloadFullSize = (type: EnumImageSizeType, options) => {
    actionFeatureClickUp(`download`);
    if (type === EnumImageSizeType.Preview) {
      actionStartDownload("download_preview");
      FTCanvasStore.downloadPreview();
      return;
    }
    actionStartDownload("download_fullsize");
    if (!FTUserStore.userInfo) {
      FTUserStore.showLogin({
        isSignIn: false,
        options: {
          position: "goart_download_fullsize"
        },
        isShowScenses: true,
        otherParam: {
          scenesId: "010",
          width: FTImageStore.currentSize.width,
          height: FTImageStore.currentSize.height,
          imgSrc: FTCanvasStore.canvas!.toDataURL("image/jpeg")
        },
        callback: (e) => {
          this.downloadFullSize(EnumImageSizeType.HD, options);
        },
        // 取消的时候
        errorCallBack: (e) => {
          if (e.code === 4) {
            utils.autoShowOpenAppConfirm();
          }
        }
      });
    } else {
      if (!FTUserStore.isVip) {
        FTUserStore.showPaymnet({
          vipType: "vip",
          position: "goart_download_hd",
          otherParam: {
            scenesId: "012"
          },
          callback: () => {
            FTCanvasStore.downloadFullSize();
          },
          isFree: options === "download_hd_free"
        });
      } else {
        FTCanvasStore.downloadFullSize();
      }
    }
  };

  prevEffect = () => {
    FTImageStore.prev();
  };

  nextEffect = () => {
    FTImageStore.next();
  };

  sliderTimer: any = null;
  onChange = (value: any) => {
    if (this.sliderTimer) {
      cancelAnimationFrame(this.sliderTimer);
      this.sliderTimer = null;
    }
    this.sliderTimer = requestAnimationFrame(() => {
      FTImageStore.changeCurrentIntensity(value);
      cancelAnimationFrame(this.sliderTimer);
      this.sliderTimer = null;
    });
  };

  handleImageHD = (isSpecail = false) => {
    if (FTCanvasStore.hasShowWater) {
      if (!FTUserStore.userInfo) {
        // 登录
        FTUserStore.showLogin({
          isSignIn: false,
          options: {
            position: "goart_close_watermark"
          },
          isShowScenses: true,
          otherParam: {
            scenesId: "010",
            width: FTImageStore.currentSize.width,
            height: FTImageStore.currentSize.height,
            imgSrc: FTCanvasStore.canvas!.toDataURL("image/jpeg")
          },
          callback: () => {
            this.handleImageHD(true);
          }
        });
        return;
      }
      if (!FTUserStore.isVip) {
        // 升级
        FTUserStore.showPaymnet({
          vipType: "vip",
          position: "goart_close_watermark",
          otherParam: {
            scenesId: "012"
          },
          callback: () => {
            this.handleImageHD(true);
          }
        });
        return;
      }
    }
    FTImageStore.imageHD = true;
  };

  handleCloseMobileAd = (e) => {
    e.stopPropagation();
    FTImageStore.setMobileShowCenterAd(false);
  };

  handleContextMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  render() {
    let {
      loading,
      showPanel,
      showWaterMark,
      currentIntensity,
      isMobile,
      waterMarkText,
      mobileShowCenterAd,
      canvasSize,
      waterShow,
      waterSize,
      showStatus,
      originCanvasSize,
      resultCanvasSize,
      containerCanvasSize
    } = this.state;
    const { width: canvasWidth, height: canvasHeight } = canvasSize;
    const currentEffect = FTImageStore.currentEffect;
    const isAigc = Boolean(FTImageStore.currentEffect?.aigc ?? false);
    const isCompare = FTCanvasStore.hasCompare;
    const { showAd } = this.props;

    const showMobileCenterAd = isMobile && mobileShowCenterAd;
    const { width: originWidth = 0, height: originHeigh = 0 } =
      originCanvasSize;
    const doubleOriginWidth = originWidth + originWidth;
    const doubleOriginHeight = originHeigh + originHeigh;
    return (
      <div
        className='canvas'
        ref={(dom) => {
          this.canvasContainRef = dom;
        }}>
        {/* showPanel */}

        <FTCanvasPanel
          drawCanvasResize={this.drawCanvasResize}
          download={this.downloadFullSize}
        />

        <div
          className='canvas_content'
          style={{
            width: withUnit(containerCanvasSize.width),
            height: withUnit(containerCanvasSize.height)
          }}
          ref={(dom) => {
            this.canvasRef = dom;
          }}>
          <canvas
            className='origin_canvas'
            width={doubleOriginWidth}
            height={doubleOriginHeight}
            ref={(dom) => (this.originalCanvasRef = dom)}
            onContextMenu={this.handleContextMenu}
            style={{
              width: withUnit(originWidth),
              height: withUnit(originHeigh),
              display:
                showStatus === EnumsShowStatus.origin ||
                showStatus === EnumsShowStatus.compare
                  ? "block"
                  : "none"
            }}
          />
          <canvas
            className='result_canvas'
            width={(resultCanvasSize.width || 0) * 2}
            height={(resultCanvasSize.height || 0) * 2}
            ref={(dom) => (this.resultCanvasRef = dom)}
            onContextMenu={this.handleContextMenu}
            style={{
              display: showStatus === EnumsShowStatus.result ? "block" : "none",
              width: withUnit(resultCanvasSize.width || 0),
              height: withUnit(resultCanvasSize.height || 0)
            }}
          />
          {waterShow && (
            <div
              className='canvas_content_water_trans'
              style={{
                display: isCompare ? "none" : "flex",
                width: withUnit(waterSize.width),
                height: withUnit(waterSize.height),
                left: withUnit(waterSize.x),
                top: withUnit(waterSize.y)
              }}
              onClick={() => {
                this.handleImageHD();
              }}>
              <div className='water_wrapper'>
                <img
                  src={withPublicUrl("img/fotor_watermark_web_4x.png")}
                  alt=''
                  className='watermark_img'
                />
                <img
                  src={withPublicUrl("img/goart_watermark_webHover.png")}
                  className='watermark_img_hover'
                  alt=''
                />
              </div>
              {((isMobile && !mobileShowCenterAd) || !isMobile) && (
                <div
                  className='water_close_wrapper'
                  style={{ display: waterSize.width === 0 ? "none" : "flex" }}>
                  <div className='water_close_svg'>
                    <IconClose width={8} />
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        <div
          className={clsx("canvas_extra", isMobile && "canvas_extra_mobile")}>
          <div
            className='canvas_extra_remove'
            data-canvasWidth={canvasWidth}
            data-canvasHeight={canvasHeight}>
            {showWaterMark && !isMobile && currentEffect && <FTWatermark />}
          </div>

          <Share isMobile={isMobile} />

          <div
            className={clsx(
              "canvas_right_bottom",
              showAd && "canvas_right_bottom_ad"
            )}>
            {currentEffect && (
              <FTimageCompare
                theme='light'
                needToolTip={true}
                placement='top'
              />
            )}
            {!isMobile && <FTMoreLink />}
          </div>
        </div>

        {loading && (
          <div className='canvas_loading'>
            <div className='canvas_loading_mask'>
              <img src={CanvasLoading} alt='' />
              <span>{FTLang._("goart_open_loading")}</span>
            </div>
          </div>
        )}
        {!isAigc && currentEffect && (
          <div className='canvas_slider'>
            <FTSlider
              value={currentIntensity}
              onChange={this.onChange}
              max={FTImageStore.intensity.max}
              min={FTImageStore.intensity.min}
              vertical
            />
          </div>
        )}

        {showMobileCenterAd && (
          <div className='canvas_mobile_center_ad'>
            <FTWatermark
              icon={<IconLargePro className='no_icon' />}
              close={true}
              onClose={(event) => this.handleCloseMobileAd(event)}>
              <IconRight className='ad_icon_right no_icon' />
            </FTWatermark>
          </div>
        )}
      </div>
    );
  }
}

export default FTCanvas;
